import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    modelSlides: [],
    isNewRecord: true,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    modelSlides: (state) => state.modelSlides,
    isNewRecord: (state) => state.isNewRecord,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.modelSlides = Array.isArray(recordsData?.modelSlides) ? recordsData.modelSlides : [];
      state.isNewRecord = Boolean(recordsData?.isNewRecord);
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const responses = await Promise.all([
          apiClient.caxACGxThoughtPt1Schema(),
          apiClient.catCognitThouTrainFormCond(),
        ]);
        const [schemaRes, catCognitThouTrainFormCond] = responses.map((res) => res?.data ?? {});

        let id1 = 'A';
        const resCat1 = await apiClient.catLevelDescription(id1);
        const catLevelDescriptionA = resCat1.data.data;

        let id2 = 'C';
        const resCat2 = await apiClient.catLevelDescription(id2);
        const catLevelDescriptionC = resCat2.data.data;

        if (!schemaRes.schemaFormItems) throw new Error('Estructura de schema inválida.');

        let schema = structuredClone(schemaRes);
        schema.schemaFormItems[0].schemaForm.group1.schema.i1_cognitive_thoughtPt1_level_description_id.items =
          catLevelDescriptionA;
        schema.schemaFormItems[0].schemaForm.group3.schema.i1_cognitive_thoughtPt1_level_description_id.items =
          catLevelDescriptionC;
        schema.schemaFormItems[0].schemaForm.group3.schema.i2_cognitive_thoughtPt1_level_description_id.items =
          catLevelDescriptionC;
        schema.schemaFormItems[0].schemaForm.group3.schema.i3_cognitive_thoughtPt1_level_description_id.items =
          catLevelDescriptionC;
        schema.schemaFormItems[0].schemaForm.group3.schema.i4_cognitive_thoughtPt1_condition_id.items =
          catCognitThouTrainFormCond.data ?? [];

        const modelFormItems = [{ modelForm: { group1: {}, group2: {} } }];

        let modelSlides = modelFormItems.map((item, i) => ({
          modelForm: item.modelForm,
          schemaForm: schema.schemaFormItems[i].schemaForm,
        }));

        const isNewRecord = true;
        const recordsData = { modelSlides, isNewRecord };
        commit('SET_SCHEMA', schema);
        commit('SET_RECORDS', recordsData);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState, getters, dispatch }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelCAxACGxThoughtPt1(clinicalHistories_id, institutions_profes_id);
        let recordsData = res?.data?.data ?? {};
        const dataModelFormItems = recordsData.modelSlides;

        if (Object.keys(getters.schema).length === 0) {
          await dispatch('fetchSchema');
        }
        const schema = JSON.parse(JSON.stringify(getters.schema));

        let modelSlides = dataModelFormItems.map((item, i) => ({
          modelForm: item.modelForm,
          schemaForm: schema.schemaFormItems[i].schemaForm,
        }));

        if (recordsData.isNewRecord === true) {
          modelSlides.cognitive_aspect_id = dataModelFormItems[0].modelForm.cognitive_aspect_id;
        }

        recordsData.modelSlides = modelSlides;
        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async createRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'create');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.createCAxACGxThoughtPt1(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');
        const preparedModel = prepareModel(rootState, model);
        const id = preparedModel.modelSlides.cognitiveAspectId;
        await apiClient.updateCAxACGxThoughtPt1(id, preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },
  },
};
